import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import LinkedTitledTextItem from "@coworker/apprestructured/src/task-management/components/LinkedTitledTextItem/LinkedTitledTextItem";
import ModalColumn from "@coworker/apprestructured/src/task-management/components/ModalColumn/ModalColumn";
import styles from "./TitledText.module.css";

type TitledTextProps = {
  title: string;
  text: string | undefined;
  toLink?: string;
};

function TitledText({ title, text, toLink }: TitledTextProps) {
  return (
    <ModalColumn gap="small">
      <FixaText textStyle="Heading.S" tagName="h2">
        {title}
      </FixaText>
      {text === undefined ? (
        <FixaSkeleton height="24px" />
      ) : toLink ? (
        <LinkedTitledTextItem text={text} toLink={toLink} />
      ) : (
        <FixaText className={styles["wrap-content"]} textStyle="Body.L">
          {text}
        </FixaText>
      )}
    </ModalColumn>
  );
}

export default TitledText;
